import React from 'react'
import PositionedTooltip from 'shared/components/PositionedTooltip/PositionedTooltip'
import list from './ListRow.module.scss'

function RowIconHintButton({
	icon,
	hint,
	onClick,
	disabled = false,
	ariaLabel,
	cooldownHint = '',
	className = '',
}) {
	const hintText = disabled && cooldownHint ? cooldownHint : hint

	const button = (
		<button
			type="button"
			className={[
				list.iconBtn,
				disabled ? list.iconBtnDisabled : '',
				className,
			]
				.filter(Boolean)
				.join(' ')}
			onClick={event => {
				event.stopPropagation()
				if (!disabled) onClick?.(event)
			}}
			disabled={disabled}
			aria-label={ariaLabel || hint}
		>
			<span className={list.iconBtnGraphic}>{icon}</span>
			{hintText ? <span className={list.iconBtnHint}>{hintText}</span> : null}
		</button>
	)

	if (disabled && cooldownHint) {
		return (
			<PositionedTooltip content={cooldownHint} enabled>
				{button}
			</PositionedTooltip>
		)
	}

	return button
}

export default RowIconHintButton
